import Crud from './crud'
import { update_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
var crud = new Crud('fee-weight-commission', 'chiết khấu phí cân nặng')

const state = {
    ...crud.state
};
const getters = {
    ...crud.getters
};
const actions = {
    ...crud.actions,
    duplicateDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        update_detail(`${crud.endpoint}/duplicate`, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không copy ${crud.viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã copy ${crud.viewTitle} thành công.`)
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, {}, id, this.state.authentication.token);
    }
};
const mutations = {
    ...crud.mutations
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};